import { render, staticRenderFns } from "./MenuTutorial.vue?vue&type=template&id=5f40984e"
import script from "./MenuTutorial.vue?vue&type=script&lang=js"
export * from "./MenuTutorial.vue?vue&type=script&lang=js"
import style0 from "./MenuTutorial.vue?vue&type=style&index=0&id=5f40984e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports